import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent } from '@mui/material';
import { motion } from 'framer-motion';
import MedicalInformationRoundedIcon from '@mui/icons-material/MedicalInformationRounded';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import MeetingRoomRoundedIcon from '@mui/icons-material/MeetingRoomRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';

const AUDIENCES = [
  {
    icon: <MedicalInformationRoundedIcon sx={{ fontSize: 26 }} />,
    title: 'Médicos PJ',
    description: 'Profissionais que atuam através de Pessoa Jurídica.',
  },
  {
    icon: <ApartmentRoundedIcon sx={{ fontSize: 26 }} />,
    title: 'Clínicas Médicas',
    description: 'Empresas que precisam oferecer benefícios para sócios e colaboradores.',
  },
  {
    icon: <MeetingRoomRoundedIcon sx={{ fontSize: 26 }} />,
    title: 'Consultórios',
    description: 'Soluções para profissionais que possuem sua própria estrutura.',
  },
  {
    icon: <GroupsRoundedIcon sx={{ fontSize: 26 }} />,
    title: 'Profissionais da Saúde',
    description: 'Outros profissionais elegíveis para planos empresariais.',
  },
];

const ParaQuemSection: React.FC = () => {
  return (
    <Box
      id="para-quem"
      component="section"
      sx={{ py: { xs: 8, md: 12 }, bgcolor: 'background.paper', scrollMarginTop: { xs: 88, md: 100 } }}
    >
      <Container maxWidth="lg">
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5 }}
          sx={{ textAlign: 'center', maxWidth: 640, mx: 'auto', mb: 7 }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: '0.8rem',
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: 'secondary.dark',
              mb: 1.5,
            }}
          >
            Para quem é
          </Typography>
          <Typography variant="h2" sx={{ fontSize: { xs: '1.75rem', md: '2.25rem' } }}>
            Você é profissional da saúde e possui CNPJ?
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {AUDIENCES.map((item, index) => (
            <Grid item key={item.title} xs={12} sm={6} md={3}>
              <Card
                component={motion.div}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, delay: index * 0.08 }}
                whileHover={{ y: -6 }}
                variant="outlined"
                sx={{
                  height: '100%',
                  border: '1px solid',
                  borderColor: 'divider',
                  boxShadow: 'none',
                  transition: 'box-shadow 0.25s ease, border-color 0.25s ease',
                  '&:hover': {
                    boxShadow: '0 16px 40px rgba(14, 75, 79, 0.12)',
                    borderColor: 'transparent',
                  },
                }}
              >
                <CardContent sx={{ p: 3.5 }}>
                  <Box
                    sx={{
                      width: 52,
                      height: 52,
                      borderRadius: '14px',
                      bgcolor: 'rgba(14, 75, 79, 0.08)',
                      color: 'primary.main',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 2.5,
                    }}
                  >
                    {item.icon}
                  </Box>
                  <Typography sx={{ fontWeight: 700, fontSize: '1.05rem', mb: 1 }}>
                    {item.title}
                  </Typography>
                  <Typography sx={{ fontSize: '0.9rem', color: 'text.secondary', lineHeight: 1.6 }}>
                    {item.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default ParaQuemSection;
